<div>
    <!--
    <h3 mat-dialog-title
        cdkDragHandle
        class="draggable-dialogue-header"
        style="">
        Edit Form Email Templates
    </h3>
    -->
    <h3 mat-dialog-title
        class="draggable-dialogue-header"
        style="">
        Select Email Template
    </h3>

    <div mat-dialog-content
         class="dialog-content-div">

        <kendo-listbox kendoListBoxDataBinding
                       [data]="this.AvailableEmailTemplates"
                       selectable="single"
                       (selectionChange)="emailTemplateSelectionChange($event)"
                       (action)="emailTemplateAction($event)"
                       textField="notificationTemplateName"
                       valueField="notificationTemplateId"
                       style="height: 200px; width: 100%;">
            <ng-template kendoListBoxItemTemplate let-dataItem let-index="index">
                <div class="rule-in-listbox">
                    <div class="rule-in-listbox-left" title="{{dataItem.notificationTemplateName}}">
                        {{ dataItem.notificationTemplateName }}
                    </div>
                </div>
            </ng-template>
        </kendo-listbox>

    </div>

    <div mat-dialog-actions class="action-buttons-div">
        <button mat-flat-button
                color="primary"
                [disabled]="false"
                style=""
                (click)="this.selectEmailTemplate()">
            Select
        </button>

        <span class="action-buttons-div-spacer"></span>

        <button mat-flat-button
                [disabled]="false"
                style=""
                (click)="this.cancelDialogue()">
            Cancel
        </button>
    </div>

</div>
